import React, { Component } from 'react';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import CreatableSelect from 'react-select/creatable';
import { DateTimePicker, DropdownList, SelectList } from 'react-widgets';
import { connect } from 'react-redux';
import { combineStates, identityState, messageDispatcher, screenSizeState } from '../../../../store';
import { AssignmentType, VariableType } from '../../../../model';
import { PropTypes, symbol } from 'prop-types';
import { translate } from '../../../../services';
import { createFilter } from 'react-select';
import { Box,Badge, Select, MenuItem, Typography } from '@mui/material';
import { arrowDownIcon, caretDownIconNew, vectorArrowUpNew,checkedIcon } from '../../../../../style/images';
import classNames from 'classnames';

export class VariableInputComponent extends Component {

  constructor(props) {
    super(props);
    this.state = { inputFieldValue: '', customOptions: [], customValue: null,symbolSelected:false , menuOpen:false, menuWidth:null }
    this.selectRef = React.createRef(null);
  }
  componentDidMount() {
    let culture = this.props.user?.culture?.substring( 0, 2 );
    moment.locale( culture );
    momentLocalizer();
  }

  // componentDidUpdate(prevProps,prevState){
  //   if(prevState.inputFieldValue!==this.state.inputFieldValue){
  //     this.nameInput.focus();
  //   }
  // }
  toValueItem(value) {
    //value = value.replace(',','.');
    let newValue = Object.assign({}, this.props.data[0]);
    newValue.name = value;
    newValue.title = value;
    newValue.state = AssignmentType.UserAssigned;
    if (this.props.showAs == "inputfield") {
      newValue.value = value;
    }
    return newValue;
  }
  handleOpen = () => {
    this.setState({menuOpen:true});
    if (this.selectRef.current) {
      this.setState({menuWidth:this.selectRef.current.offsetWidth}); // Get Select width
    }
  };

  handleClose = () => {
    this.setState({menuOpen:false});
  };

  getInputPattern = e => {
    const { type } = this.props;
    if (type === VariableType.Int || VariableType[type] === VariableType.Int) {
      return '^([+-]?[0-9]\d*|0)$';
    }
    else if (type == 'float') {
      return true;
    }
    else {
      return '';
    }
    /* return type === VariableType.Int || VariableType[type] === VariableType.Int 
      ? '^([+-]?[0-9]\d*|0)$':''; */
  }

  onCustomChange = e => this.props.onChange(this.toValueItem(e))

  isInteger = () => this.props.type === VariableType.Int || VariableType[this.props.type] === VariableType.Int

  onBlur = e => {
    const { onChange, max, min, value, type } = this.props;

    if (!e.target.value) {
      e.target.value = this.getdefaultValueforInput(value);
      return;
    }
    if (type != 'float' || this.validateInput(e.key, e.target.value, true)) {
      if (!e.target.validity.valid && e.target.validity.stepMismatch) {
        e.target.value = value || '';
        this.props.addMessage({ messageText: translate('Please enter a whole number'), messageType: 'warning', timeout: 5000 });
        return;
      }

      if (!e.target.validity.valid && (e.target.validity.rangeOverflow || e.target.validity.rangeUnderflow)) {
        e.target.value = value || '';
        this.props.addMessage({ messageText: translate('Please enter a value in the range of {min} to {max}', { min, max }), messageType: 'warning', timeout: 5000 });
        return;
      }

      if (!this.checkRange(e.target.value, max, min)) {
        e.target.value = this.getdefaultValueforInput(value) || '';
        this.props.addMessage({ messageText: translate('Please enter a value in the range of {min} to {max}', { min, max }), messageType: 'warning', timeout: 5000 });
        return;
      }
    }
    else {
      e.target.value = this.getdefaultValueforInput(value) || '';
      this.props.addMessage({ messageText: translate('Please enter a valid value'), messageType: 'warning', timeout: 5000 });
      return;
    }

    this.setState({ inputFieldValue: e.target.value });
    value !== e.target.value && onChange(this.toValueItem(e.target.value), this.props.showAs);
  }

  onChange = e => {
    if (!e.target.value && e.target.value!='') {
      if (this.props.type != 'number') {
        this.props.onChange(this.toValueItem('[Other values]'), this.props.showAs);
      }
      else {
        this.props.onChange(this.toValueItem(0), this.props.showAs);
      }
      return;
    }
    this.setState({ inputFieldValue: e.target.value });
  }

  increment = ()=>{    
    let inputCurrentvalue = document.querySelector(`input[id=${CSS.escape(this.props.fqn)}]`);
    let currentvalue = parseInt(inputCurrentvalue.value) 
    currentvalue = isNaN(currentvalue) ? 0 + 1 : currentvalue + 1;
    inputCurrentvalue.value = String(currentvalue);    
  }

  decrement = ()=>{
    let inputCurrentvalue = document.querySelector(`input[id=${CSS.escape(this.props.fqn)}]`)
    let currentvalue = parseInt(inputCurrentvalue.value) 
    if(!isNaN(currentvalue)) {
      if(currentvalue !== 0) {
        currentvalue = String(parseInt(currentvalue) - 1)
        inputCurrentvalue.value = currentvalue;
      }
    }
  }
  onKeyPress = e => {
    const { onChange, max, min, value, type } = this.props;
    if(this.props.fqn=="Selector.varCompleteratioA"){
      if((this.props.model=="VT_SP" || this.props.model=="VT_SP+F" || this.props.model=="VT_DP" )){
        if(e.key=="r" || e.key=="v"){
          e.preventDefault();
           const val=':v3';
           e.target.value=e.target.value+val   
       }     
     }
    }
    if(this.props.fqn.indexOf("Accuracyclass")>=0 || this.props.fqn.indexOf("Burden")>=0){
      if((this.props.model=="VT_SP" || this.props.model=="VT_SP+F" || this.props.model=="VT_DP" )){ 
        if(e.key==',' || e.key=='.'){
          e.preventDefault();
          e.target.value=e.target.value+','
      }}
    }
    if (type != 'float' || this.validateInput(e.key, e.target.value, true, false)) {
      //e.key.replace(',','.');
      if (e.key === 'Enter') {
        if (!e.target.value) {
          e.target.value = value || '';
          return;
        }

        if (!e.target.validity.valid && e.target.validity.stepMismatch) {
          e.target.value = value || '';
          this.props.addMessage({ messageText: translate('Please enter a whole number'), messageType: 'warning', timeout: 5000 });
          return;
        }

        if (!e.target.validity.valid && (e.target.validity.rangeOverflow || e.target.validity.rangeUnderflow)) {
          e.target.value = value || '';
          this.props.addMessage({ messageText: translate('Please enter a value in the range of {min} to {max}', { min, max }), messageType: 'warning', timeout: 5000 });
          return;
        }

        if (!this.checkRange(e.target.value, max, min)) {
          e.target.value = this.getdefaultValueforInput(value) || '';
          this.props.addMessage({ messageText: translate('Please enter a value in the range of {min} to {max}', { min, max }), messageType: 'warning', timeout: 5000 });
          return;
        }
        this.setState({ inputFieldValue: e.target.value });
        value !== e.target.value && onChange(this.toValueItem(e.target.value));
      }
    }
    else {
      e.target.value = this.getdefaultValueforInput(value) || '';
      this.props.addMessage({ messageText: translate('Please enter a valid value'), messageType: 'warning', timeout: 5000 });
      return;
    }
  }

  validateInput(value, targetValue, onBlur) {
    //let regEx = new RegExp( '^([+-]?[0-9]\d*|0)$' );
    let hasmultileSeperator = false;
    if ((value == '.' || value == ',') && (targetValue.indexOf('.') > -1 || targetValue.indexOf(',') > -1)) {
      hasmultileSeperator = true;
    }
    value = onBlur ? targetValue : value;
    value = value == 'Enter' ? targetValue : value;
    let regEx = /^[+-]?\d*(?:[.,]\d*)?$/;
    if (regEx.test(value) && hasmultileSeperator == false) {
      return true;
    }
    else {
      return false;
    }
  }

  checkRange(value, max, min) {
    value = value.replace(',', ('.'));
    if (parseFloat(value) > parseFloat(max) || parseFloat(value) < parseFloat(min)) {
      return false;
    }
    return true;
  }

  getdefaultValueforInput(value) {
    return value == '[Other values]' ? '' : value;
  }

  onAvailableChange = e => this.props.onChange && this.props.onChange(e);

  handleCreate = (inputValue) => {
    const newValue = { value: inputValue.toLowerCase(), label: inputValue, name: inputValue.toLowerCase() };
    this.setState({ customOptions: [...this.state.customOptions, newValue], customValue: newValue });
    this.handleChange(newValue);
  }

  handleChange = (inputValue) => {
    this.setState({ customValue: inputValue });
    this.props.onChange({ name: inputValue?.value, title: inputValue?.label });
  }

  getColor = (item) =>{
    let colors = [
      {name:'Clear', backgroundColor:'lightGray'},
      {name:'Aluminum', backgroundColor:'radial-gradient(50% 50% at 50% 50%, #DBDBDB 0%, #757575 100%)'},
      {name:'Aluminum/Yellow', backgroundColor:'linear-gradient(90deg, #DBDBDB 0%, #EDE56F 100%)'}]
    
    let foundColor = colors.find(c=>c.name===item.name);
    return foundColor?foundColor.backgroundColor : item.name;
  }

  getInputComponent() {
    var flag=false;
    const {
      showAs,
      calculatedValue,
      filter,
      disabled,
      onChange,
      placeholder,
      max = '',
      min = '',
      multiple,
      data,
      itemComponent,
      listComponent,
      listProps,
      valueComponent,
      textField,
      type = 'text',
      valueField,
      value,
      fromSelector,
      custom,
      assignedValue,
      identifier,
      fqn,
      model,
      placeholder_value,
      selectedValue
    } = this.props;
    if(fqn=="Selector.varAdditionalspecification"){
      flag=true;
    }
    else{
      flag=false;
    }

    switch (showAs) {
        case 'icon':
        selectedValue && data.splice(data.indexOf(selectedValue),1)
        selectedValue && data.unshift(selectedValue);   
        return <div className='main-frame-symbol-icon-selector'>
          <div className='symbol-icon-selector'>
            <div className='symbol-icon-selector-icons'>
              {data.slice(0,9).map((icon=>{
                return selectedValue && selectedValue.name==icon.name? <div className={classNames('symbol-icon-selector-icon-frame', {'selected':selectedValue && selectedValue.name==icon.name})} style={{border:"5px solid var(--Primary-Color-Grey-30, #BABABA)"}} onClick={(e)=>{this.props.onChange(icon)}}>
                  <Box component='img' className="symbol-icon-selector-icon-selected" src={`../publicNewUI/${icon.name}.svg`} onClick={(e)=>{this.props.onChange(icon)}} >                    
                  </Box>
                  <Box component='img' className='symbol-icon-selector-icon-checked' src={checkedIcon} onClick={(e)=>{this.props.onChange(icon)}}></Box>
                </div>:
                <div className='symbol-icon-selector-icon-frame' onClick={(e)=>{this.props.onChange(icon)}}>
                  <Box component='img' className="symbol-icon-selector-icon" src={`../publicNewUI/${icon.name}.svg`} alt={icon.name} onClick={(e)=>{this.props.onChange(icon)}} >                    
                  </Box>
                </div>

               }))}
              
            </div>
            {data && data.length>9 && <div className='symbol-icon-selector-icons-showAll' onClick={(e)=>{this.props.openAllOptions(data)}}>{'Show all'}</div>}
          </div>
        </div>
      case 'calculated':
      case 'readonly':
        return <span className="variable-input-calculated">{calculatedValue || ''}</span>;
      case 'select':
        return <SelectList
          data={data}
          disabled={disabled}
          onChange={this.onAvailableChange}
          itemComponent={itemComponent}
          listComponent={listComponent}
          listProps={listProps}
          valueComponent={valueComponent}
          textField={textField}
          valueField={valueField}
          value={[value]}
          multiple={multiple}
        />;
      case 'date':
        return <DateTimePicker
          disabled={disabled}
          defaultValue={new Date()}
          onChange={this.onCustomChange}
          time={false}
        />;
      case 'boolean':
      case 'dropdown':
      case 'radiobutton':
        const options = [...data.map(d => ({ label: d.title, value: d.name })), ...this.state.customOptions];
        return showAs === 'dropdown' && custom ?
          <CreatableSelect
            isClearable
            isDisabled={disabled}
            placeholder={placeholder || 'select option'}
            options={options}
            onChange={this.handleChange}
            onCreateOption={this.handleCreate}
            value={this.state.customValue || (assignedValue ? { value: assignedValue.name, label: assignedValue.title } : null)}
            onKeyPress={this.onKeyPress}
            filterOption={createFilter({ matchFrom: "start" })}
          />
          : flag?
          // <DropdownList filter={filter === false ? false : filter}
          //   disabled={disabled}
          //   placeholder={placeholder_value || '-- select option --'}
          //   data={data}
          //   onChange={onChange}
          //   onKeyPress={this.onKeyPress}
          //   itemComponent={itemComponent}
          //   valueComponent={valueComponent}
          //   textField={textField}
          //   valueField={valueField}
          //   value={value ? [value] : null}
          //   field={fqn}
          //   model={model}
          //   />
          <Select
          value={selectedValue || selectedValue===null? selectedValue: value ? [value] : null}
          displayEmpty
          onOpen={this.handleOpen}
          onClose={this.handleClose}
          ref = {this.selectRef}
          onChange={(e) =>{ onChange(e.target.value) } }
          className={classNames("select-element",{"model-configurator":true, "menu-open":this.state.menuOpen, "value-selected":selectedValue})}
          onKeyDown={this.onKeyPress}
          renderValue={(selected) => {
            if (!selectedValue) {
              return  placeholder_value || '-- select option --' 
            }
            return typeof valueField === 'function'?valueField(selected): selected.value?selected.value:value;
          }}
          MenuProps={{classes: {paper: 'select-menu-paper'},
          MenuListProps: {
            className: 'select-ul',
            sx: {
              maxWidth: this.state.menuWidth ? `${this.state.menuWidth}px` : 'auto',
            }
          },
          sx: {
            '.MuiBackdrop-root': {
              opacity: '0 !important',
              '&.select-backdrop': {
                opacity: '0 !important',
              },
            },
          },
        }}
        >
              {data.map(v=><MenuItem className={classNames("menu-item")} sx={{ '&.Mui-focusVisible': { backgroundColor: 'transparent' },
            '&.Mui-selected': { 
              backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
              background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
              '&.Mui-selected:hover': { 
                backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
                '&.Mui-selected.Mui-focusVisible': {
                  backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' }
              }} 
              disableRipple disableTouchRipple value={v}>{typeof textField === 'function'?textField(v): textField}</MenuItem>)}
        </Select>
            :
        //   <DropdownList filter={filter === false ? false : filter}
        //   disabled={disabled}
        //   placeholder={placeholder_value || '-- select option --'}
        //   data={data}
        //   // defaultValue={data[0]?.value}
        //   //defaultValue = {value ? [value] : data[0]?.value} SDDC-334 was part of new UI Figma but now requirement is to revert
        //   onChange={onChange}
        //   onKeyPress={this.onKeyPress}
        //   itemComponent={itemComponent}
        //   valueComponent={valueComponent}
        //   textField={textField}
        //   valueField={valueField}
        //   value={selectedValue || selectedValue===null? selectedValue: value ? [value] : null}
        //   field={fqn}
        //   model={model}
        // />
        <Select
        value={selectedValue || selectedValue===null? selectedValue: value ? [value] : null}
        displayEmpty
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        ref = {this.selectRef}
        onChange={(e) =>{ onChange(e.target.value) } }
        className={classNames("select-element",{"model-configurator":true, "menu-open":this.state.menuOpen, "value-selected":selectedValue})}
        onKeyDown={this.onKeyPress}
        renderValue={(selected) => {
          if (!selectedValue) {
            return  placeholder_value || '-- select option --' 
          }
            return typeof valueField === 'function'?valueField(selected): selected.value?selected.value:value;
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'inherit !important',
              outline: 'none',
              boxShadow: 'none',
            }
          },
        }}
        MenuProps={{classes: {paper: 'select-menu-paper'},
        MenuListProps: {
          className: 'select-ul',
          sx: {
            maxWidth: this.state.menuWidth ? `${this.state.menuWidth}px` : 'auto',
          }
        },
        sx: {
          '.MuiBackdrop-root': {
            opacity: '0 !important',
            '&.select-backdrop': {
              opacity: '0 !important',
            },
          },
        },
      }}
      >
            {data.map(v=><MenuItem className={classNames("menu-item")} sx={{ '&.Mui-focusVisible': { backgroundColor: 'transparent' },
            '&.Mui-selected': { 
              backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
              background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
              '&.Mui-selected:hover': { 
                backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' },
                '&.Mui-selected.Mui-focusVisible': {
                  backgroundColor: 'var(--primary-color-background-tertiary-white, #F5F5F5)', 
                background:'var(--primary-color-background-tertiary-white, #F5F5F5)' }
              }}
             disableRipple disableTouchRipple value={v}>{typeof textField === 'function'?textField(v): textField}</MenuItem>)}
      </Select>
      case 'inputfield':
        const defaultValue = type === 'float' ? this.getdefaultValueforInput(value) : value && value.toString();
        const inputFieldValue = this.state.inputFieldValue || defaultValue;
        return <div className="variable-input rw-widget">
          {this.props.screenSize.width>900?<>
          <input
            type={type === 'text' || type == 'float' ? type : 'number'}
            max={max}
            min={min}
            pattern={this.getInputPattern()}
            step={this.isInteger() ? '1' : 'any'}
            disabled={disabled}
            placeholder={disabled ? '' : translate('Enter The Value')}
            className={fromSelector ? "variable-input-field rw-input rw-widget-picker rw-widget-container-inputfield" : "variable-input-field rw-input rw-widget-picker rw-widget-container"}
            // defaultValue={ type === 'float' ? this.getdefaultValueforInput(value) : value && value.toString() }
            value={inputFieldValue}
            onBlur={this.onBlur}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
            id={fqn}
          />
          {!disabled &&
                    <div className='btn-stack' tabindex="0" onBlur={ () => {                      
                    document.querySelector(`input[id=${CSS.escape(this.props.fqn)}]`).focus()
                    document.querySelector(`input[id=${CSS.escape(this.props.fqn)}]`).blur()
                    // this.inputRef.current.blur()
                    }}>
                    <div class="btn-plus" onClick={this.increment} >
                      <Box component="img" src={vectorArrowUpNew} sx={{height:"7px", width:"12px"}}></Box>
                    </div>
                    <div class="btn-minus" onClick={this.decrement} >
                      <Box component="img" src={vectorArrowUpNew} sx={{height:"7px", width:"12px", transform:"rotate(180deg)"}}></Box>
                    </div>
                  </div>
          }
          </>:<>
          <div class="btn-minus" onClick={this.decrement}>
            <Box component="img" src={arrowDownIcon}></Box>
          </div>
          <input
            type={type === 'text' || type == 'float' ? type : 'number'}
            max={max}
            min={min}
            pattern={this.getInputPattern()}
            step={this.isInteger() ? '1' : 'any'}
            disabled={disabled}
            placeholder={disabled ? '' : translate('Enter The Value')}
            className={fromSelector ? "variable-input-field rw-input rw-widget-picker rw-widget-container-inputfield" : "variable-input-field rw-input rw-widget-picker rw-widget-container"}
            // defaultValue={ type === 'float' ? this.getdefaultValueforInput(value) : value && value.toString() }
            value={inputFieldValue}
            onBlur={this.onBlur}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
          />
          <div class="btn-plus" onClick={this.increment}>
            <Box component="img" src={arrowDownIcon}></Box>
          </div>
          </>}
        </div>;
      case 'textarea':
        return <div className="variable-input rw-widget">
          <textarea disabled={disabled} className="variable-input-textarea rw-input rw-widget-picker rw-widget-container" defaultValue={value && value.toString()} onBlur={this.onBlur} />
        </div>;
      case 'colorgallery': 
         return <div className='colorGallery-block'>
          {data.map((item) => {
          return <div >
          <div style={{maxHeight:'66px'}}><input type="radio" className='colorGallery-select' name="color" id={item.title} onClick={() => this.props.onChange(item )} checked = {selectedValue ? selectedValue?.title === item.title : '' } />
          <label for={item.title} className={classNames('colorGallery-label', {"selected":selectedValue &&selectedValue?.title === item.title})}><span class="colorGallery-section" style={{background: this.getColor(item), border: selectedValue &&selectedValue?.title === item.title ? '5px solid var(--Primary-Color-Grey-30, #BABABA)' :'1px solid var(--Primary-Color-Grey-30, #BABABA)'}} ></span>
          {selectedValue && selectedValue?.title === item.title ? <img className='checkedIcon' src={checkedIcon} style= {{position:'relative',bottom:'62px',left:'50px'}}></img> : null}
          </label></div>
           <div className='colorGallery-name-block'><span>{item.title}</span></div>
          </div>
          }) }
         </div>   
      default:
        return null;
    }
  }

  render() {
    return this.getInputComponent();
  }
}

VariableInputComponent.propTypes = {
  addMessage: PropTypes.func.isRequired,
  showAs: PropTypes.string.isRequired,
  calculatedValue: PropTypes.string,
  filter: PropTypes.oneOfType([PropTypes.oneOf(['contains', 'startsWith', 'endsWith']), PropTypes.bool]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  max: PropTypes.number,
  min: PropTypes.number,
  multiple: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  itemComponent: PropTypes.node,
  listComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  listProps: PropTypes.shape({}),
  placeholder: PropTypes.string,
  valueComponent: PropTypes.node,
  textField: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueField: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  value: PropTypes.string,
  user: PropTypes.shape({
    culture: PropTypes.string.isRequired
  })
}; 

export const VariableInput = connect( combineStates(identityState, screenSizeState) , messageDispatcher)(VariableInputComponent);